import {
	DEFAULT_AWARD_COLUMN_HEADERS,
	DEFAULT_MODIFICATION_COLUMN_HEADERS,
	DEFAULT_PROPOSAL_COLUMN_HEADERS,
	DEFAULT_SUBAWARD_COLUMN_HEADERS,
	DEFAULT_SUBAWARD_MODIFICATION_COLUMN_HEADERS,
} from "globals/constants";
import { TASK_ACTIVE_COLUMN } from "globals/constants/task";
import { columns as constants } from "store/constants";
import {
	getStoredAwardsActiveColumns,
	getStoredProposalActiveColumns,
	getStoredProjectActiveColumns,
	getStoredSubawardsActiveColumns,
	getStoredModificationsActiveColumns,
	getStoredTasksActiveColumns,
	getSubawardModificationsActiveColumns,
} from "utils";

const initialState = {
	awards: {
		availableColumns: [],
		activeColumns: getStoredAwardsActiveColumns() ?? DEFAULT_AWARD_COLUMN_HEADERS,
		defaultColumnHeaders: DEFAULT_AWARD_COLUMN_HEADERS,
	},
	projects: {
		availableColumns: [],
		activeColumns: getStoredProjectActiveColumns() ?? [],
		defaultColumnHeaders: [],
	},
	proposals: {
		availableColumns: [],
		activeColumns: getStoredProposalActiveColumns() ?? DEFAULT_PROPOSAL_COLUMN_HEADERS,
		defaultColumnHeaders: DEFAULT_PROPOSAL_COLUMN_HEADERS,
	},
	subawards: {
		availableColumns: [],
		activeColumns: getStoredSubawardsActiveColumns() ?? DEFAULT_SUBAWARD_COLUMN_HEADERS,
		defaultColumnHeaders: DEFAULT_SUBAWARD_COLUMN_HEADERS,
	},
	modifications: {
		availableColumns: [],
		activeColumns: getStoredModificationsActiveColumns() ?? DEFAULT_MODIFICATION_COLUMN_HEADERS,
		defaultColumnHeaders: DEFAULT_MODIFICATION_COLUMN_HEADERS,
	},
	subawardModifications: {
		availableColumns: [],
		activeColumns: getSubawardModificationsActiveColumns() ?? DEFAULT_SUBAWARD_MODIFICATION_COLUMN_HEADERS,
		defaultColumnHeaders: DEFAULT_MODIFICATION_COLUMN_HEADERS,
	},
	tasks: {
		availableColumns: [],
		activeColumns: getStoredTasksActiveColumns() ?? TASK_ACTIVE_COLUMN,
		defaultColumnHeaders: TASK_ACTIVE_COLUMN,
	}
};

const reduceSetAvailableColumns = (state, key, { payload }) => ({
	...state,
	[key]: {
		...state[key],
		availableColumns: [ ...payload.availableColumns ],
		defaultColumnHeaders: [ ...payload.defaultColumnHeaders ],
	},
});

const reduceSetActiveColumns = (state, key, { columns }) => ({
	...state,
	[key]: {
		...state[key],
		activeColumns: [ ...columns ],
	},
});

export function columns (state = initialState, action) {
	switch (action.type) {
	case constants.AWARDS_SET_ACTIVE_COLS:
		return reduceSetActiveColumns(state, "awards", action);
	case constants.AWARDS_SET_AVAILABLE_COLS:
		return reduceSetAvailableColumns(state, "awards", action);

	case constants.PROJECTS_SET_ACTIVE_COLS:
		return reduceSetActiveColumns(state, "projects", action);
	case constants.PROJECTS_SET_AVAILABLE_COLS:
		return reduceSetAvailableColumns(state, "projects", action);

	case constants.PROPOSALS_SET_ACTIVE_COLS:
		return reduceSetActiveColumns(state, "proposals", action);
	case constants.PROPOSALS_SET_AVAILABLE_COLS:
		return reduceSetAvailableColumns(state, "proposals", action);

	case constants.SUBAWARDS_SET_ACTIVE_COLS:
		return reduceSetActiveColumns(state, "subawards", action);
	case constants.SUBAWARDS_SET_AVAILABLE_COLS:
		return reduceSetAvailableColumns(state, "subawards", action);

	case constants.MODIFICATIONS_SET_ACTIVE_COLS:
		return reduceSetActiveColumns(state, "modifications", action);

	case constants.SUBAWARDS_MODIFICATIONS_SET_ACTIVE_COLS:
		return reduceSetActiveColumns(state, "subawardModifications", action);

	case constants.TASKS_SET_ACTIVE_COLS:
		return reduceSetActiveColumns(state, "tasks", action);

	default:
		return state;
	}
}
